import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-modal-emissao-cartao',
  templateUrl: './modal-emissao-cartao.component.html',
  styleUrls: ['./modal-emissao-cartao.component.scss']
})
export class ModalEmissaoCartaoComponent implements OnInit {

  @Input() emitirCartao: string;

  public customLogin = null;
  public title = 'Confirmar Importação de Funcionários';
  public nDescricao = 'Essa importação não solicitará a 1° via dos cartões.';
  public nSubDescricao = 'Tem certeza que deseja continuar?';
  public sDescricao = 'Essa importação solicitará a 1° via dos cartões.';
  public sSubDescricao = 'Tem certeza que deseja continuar?';

  public descricao = null;
  public subDescricao = null;

  constructor(protected ref: NbDialogRef<ModalEmissaoCartaoComponent>) { }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);

    if (this.emitirCartao == 'S') {
      this.descricao = this.sDescricao;
      this.subDescricao = this.sSubDescricao;
    } else {
      this.descricao = this.nDescricao;
      this.subDescricao = this.nSubDescricao;
    }

  }

  confimar() {
    this.ref.close(true);
  }

  closeModal() {
    this.ref.close(false);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}